module.exports = __webpack_public_path__ + "img/proceso_b.17e46649.png";